import { useNavigate } from "react-router-dom";
import { Eye, LogOut } from "lucide-react";
import { useI18n } from "../../i18n";
import { useAuth } from "../../context/AuthContext";

// Yellow bar while a power admin views the app as a customer (read-only).
export const ViewAsBar = () => {
  const { t } = useI18n();
  const { user, exitViewAs } = useAuth();
  const nav = useNavigate();
  const v = JSON.parse(sessionStorage.getItem("vavlis.viewas") || "null");
  if (!v || user?.type !== "customer") return null;
  const exit = async () => { const code = await exitViewAs(); nav(code ? `/staff/customers/${encodeURIComponent(code)}` : "/staff"); };
  return (
    <div className="sticky top-0 z-50 flex flex-wrap items-center gap-2 bg-amber-300 px-4 py-2 text-sm font-semibold text-navy" data-testid="view-as-bar">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1 truncate">{t("viewas.bar", { name: v.name })} · {t("viewas.readOnly")}</span>
      <button type="button" onClick={exit} className="inline-flex h-9 items-center gap-1 rounded-full bg-navy px-4 text-white" data-testid="view-as-exit"><LogOut className="h-4 w-4" />{t("viewas.exit")}</button>
    </div>
  );
};
